var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInline)?_c('i',{class:_vm.customClass,domProps:{"innerHTML":_vm._s(_vm.svgContent)}}):_c('img',{class:_vm.customClass,attrs:{"src":_vm.imgSrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }